import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export class Deadend<V = any, E = any, C = any> extends Pass<V, E, C> {
    value() {
        // do nothing :)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        deadend(): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.deadend = function <V, E, C>(this: AnySourceStream<V, E, C>) {
    return new Deadend(this) // tslint:disable-line:no-invalid-this
}
